import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-[#F5EBE0]/30" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <FadeIn data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-128">
            Esto no es un planner más
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-129">
          <FadeIn delay={0.1} data-id="element-130">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-stone-100" data-id="element-131">
              <p className="text-lg text-stone-700 mb-6" data-id="element-132">
                Si ya compraste agendas, descargaste apps, guardaste rutinas de
                TikTok… y aun así terminas en caos, no es porque "no te
                comprometiste".
              </p>
              <p className="font-semibold text-stone-900 mb-4" data-id="element-133">
                Es porque esos métodos asumen una vida con:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-134">
                {['Energía constante', 'Tiempo constante', 'Ayuda constante'].map(item => <li key={item} className="flex items-center text-stone-600" data-id="element-135">
                    <XCircle className="w-5 h-5 text-red-400 mr-3 flex-shrink-0" data-id="element-136" />
                    {item}
                  </li>)}
              </ul>
              <p className="text-[#C75B3F] font-medium italic" data-id="element-137">
                Y tú no tienes eso. Tú estás criando en un país que exige mucho
                y perdona poco… con una red mínima.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-138">
            <div className="space-y-8" data-id="element-139">
              <div data-id="element-140">
                <h3 className="text-xl font-bold text-stone-900 mb-4 flex items-center" data-id="element-141">
                  <AlertCircle className="w-6 h-6 text-[#C75B3F] mr-2" data-id="element-142" />
                  El problema real: tu semana no tiene contenedores
                </h3>
                <p className="text-stone-600 mb-4" data-id="element-143">
                  Cuando todo vive en tu cabeza:
                </p>
                <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-[#C75B3F]" data-id="element-144">
                  <li data-id="element-145">Cualquier imprevisto te tumba</li>
                  <li data-id="element-146">Cualquier tarde mala arruina la noche</li>
                  <li data-id="element-147">Cualquier mañana tarde te persigue el resto del día</li>
                </ul>
              </div>

              <div className="bg-[#C75B3F]/5 p-6 rounded-2xl" data-id="element-148">
                <p className="text-stone-600 mb-4" data-id="element-149">
                  Y encima llega la culpa. Esa culpa que se siente así:
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-150">
                  {['"debería poder"', '"otras pueden"', '"yo me lo busqué"', '"soy un desastre"'].map(phrase => <span key={phrase} className="bg-white px-3 py-1 rounded-full text-sm text-stone-500 border border-stone-200" data-id="element-151">
                      {phrase}
                    </span>)}
                </div>
                <p className="mt-6 font-bold text-lg text-stone-900 text-center" data-id="element-152">
                  No eres un desastre.{' '}
                  <span className="text-[#C75B3F]" data-id="element-153">Estás sobrecargada.</span>
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}